import React from "react";
import styles from "@/components/PremiumFeatureComponents/PremiumFeatures.module.scss";
import { Button, Col, Row, Space } from "antd";
import { LockTwoTone } from "@ant-design/icons";
import PremiumContactUs from "@/components/PremiumFeatureComponents/PremiumContactUs";
import { useNavigate } from "react-router-dom";

function PremiumBanner() {
  const navigate = useNavigate();

  return (
    <div className={styles.premiumBannerContainer}>
      <Row
        gutter={[10, 10]}
        style={{ width: "100%" }}
      >
        <Col span={24}>
          <Space align={"start"}>
            <div className={styles.lockContainer}>
              <LockTwoTone
                twoToneColor={["#1890FF", "#CDEAFF"]}
                style={{ fontSize: "16px" }}
              />
            </div>
            <Space
              direction={"vertical"}
              size={4}
            >
              <span className={styles.heading}>Premium feature, ready to upgrade?</span>
              <span className={styles.description}>
                Ready for deeper insights? Explore features below and contact us for a detailed
                demo.
              </span>
            </Space>
          </Space>
        </Col>
      </Row>
      <Row
        justify={"end"}
        className={styles.buttonsContainer}
      >
        <Col>
          <Space>
            <Button
              type={"link"}
              onClick={() => navigate("/explore_features")}
            >
              Explore features
            </Button>
            <PremiumContactUs />
          </Space>
        </Col>
      </Row>
    </div>
  );
}

export default PremiumBanner;
